import { Component, Input, OnInit } from '@angular/core';
import { iif, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { CallHistoryBrowserBehaviourState } from '../../../store/dashboard/brick-wall/brick-behaviour-state/brickTypes/call-history-browser-behaviour/call-history-browser-behaviour.state';
import _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';

@Component({
   selector: 'samweb-call-memo',
   templateUrl: './call-memo.component.html',
   styleUrls: ['./call-memo.component.scss'],
})
export class CallMemoComponent implements OnInit {
   constructor(private store: Store, private translateService: TranslateService) {}

   @Input()
   public callHistoryForCallId: number;
   @Input()
   public origMemoValue: string;
   @Input()
   public searchValue: string[];

   public shownMemoValue$: Observable<any>;

   ngOnInit(): void {
      this.shownMemoValue$ = this.store
         .select(CallHistoryBrowserBehaviourState.getMemoForHistoryEntryFn)
         .pipe(map((fn) => fn(this.callHistoryForCallId.toString())))
         .pipe(
            switchMap((c) => {
               if (_.isEmpty(c)) {
                  return of(this.origMemoValue);
               }
               return of(c);
            })
         );
   }
}
